import type { SxProps, Theme } from '@mui/material';

export const titleTypography: SxProps<Theme> = {
  mb: 3,
  fontFamily: 'Space Grotesk, sans-serif',
  fontWeight: 700,
  fontSize: { xs: 24, sm: 32 },
};

export const loadingContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  py: 4,
};

export const errorTypography: SxProps<Theme> = {
  textAlign: 'center',
  py: 4,
};

export const headerContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: 3,
};

export const emptyStateTypography: SxProps<Theme> = {
  textAlign: 'center',
  py: 4,
};

export const collectionsContainer: SxProps<Theme> = {
  display: 'flex',
  gap: 2,
  alignItems: 'stretch',
};

export const collectionCardContainer: SxProps<Theme> = {
  flex: 1,
  // Allow the flex item to shrink below its intrinsic content size, otherwise
  // a card with a long title can push past its equal-width share of the row.
  minWidth: 0,
};

export const browseButton: SxProps<Theme> = {
  borderRadius: 2,
  textTransform: 'none',
  fontFamily: 'Space Grotesk, sans-serif',
  fontWeight: 500,
};
